var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#316DBE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0019 3.4375H7.99808C7.96582 2.91433 7.53129 2.5 7 2.5C6.46871 2.5 6.03418 2.91433 6.00192 3.4375H5C3.34315 3.4375 2 4.6967 2 6.25V6.99999V7.5V14.9219C2 16.3457 3.34315 17.5 5 17.5H15C16.6569 17.5 18 16.3457 18 14.9219V7.5V6.99999V6.25C18 4.6967 16.6569 3.4375 15 3.4375H13.9981C13.9658 2.91433 13.5313 2.5 13 2.5C12.4687 2.5 12.0342 2.91433 12.0019 3.4375Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 12,
    height: 8,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7ed211dc2194b6671e0b937a674c19f4.svg";
export { ForwardRef as ReactComponent };